/**
 * SRS · studentreliefsolutions.com · main.js
 * Mobile nav toggle for .srs-brand-bar
 */
(function () {
    'use strict';

    // Mobile menu toggle
    var toggle = document.querySelector('[data-srs-menu-toggle]');
    var header = document.querySelector('.srs-brand-bar');
    var mobileNav = document.getElementById('srs-brand-bar-mobile');

    if (toggle && header) {
        toggle.addEventListener('click', function () {
            var isOpen = header.getAttribute('data-open') === 'true';
            header.setAttribute('data-open', isOpen ? 'false' : 'true');
            toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            if (mobileNav) {
                mobileNav.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
            }
        });
    }

    // Close mobile menu on outside click
    document.addEventListener('click', function (e) {
        if (header && header.getAttribute('data-open') === 'true') {
            if (!header.contains(e.target)) {
                header.setAttribute('data-open', 'false');
                if (toggle) toggle.setAttribute('aria-expanded', 'false');
                if (mobileNav) mobileNav.setAttribute('aria-hidden', 'true');
            }
        }
    });

})();
